module.exports = __webpack_public_path__ + "static/media/EE6060.c90b1dec.svg";